module.exports = __webpack_public_path__ + "static/media/mobile-mask@2x.7bd067b6.png";